import React, { useState } from "react";
import { Box, Typography, useMediaQuery, useTheme } from "@mui/material";
import { Zap } from "lucide-react";
import RenderUserFavoriteCards from "./UserBookedMarked";
import GradientToggleButtonGroup from "../../../../common/GradientToggleButtonGroup";
import { Icons } from "../../../../assets/icon";
type SuitType = "recommended" | "Heart" | "Spade" | "Diamond" | "Clover";

const SUITS: { label: string; value: SuitType; icon: JSX.Element }[] = [
  { label: "All", value: "recommended", icon: <Zap size={18} /> },
  {
    label: "Heart",
    value: "Heart",
    icon: <Icons.HeartIcon height={18} width={18} />,
  },
  {
    label: "Spade",
    value: "Spade",
    icon: <Icons.SpadeIcon height={18} width={18} />,
  },
  {
    label: "Diamond",
    value: "Diamond",
    icon: <Icons.DiamondIcon height={18} width={18} />,
  },
  {
    label: "Clover",
    value: "Clover",
    icon: <Icons.CloverIcon height={18} width={18} />,
  },
];

const MyBookmarks = () => {
  const [selectedSuit, setSelectedSuit] = useState<SuitType>("recommended");
  const [selectedTitle, setSelectedTitle] = useState("All");

  const theme = useTheme();
  const isXs = useMediaQuery(theme.breakpoints.only("xs"));
  const isSm = useMediaQuery(theme.breakpoints.only("sm"));
  const isMdUp = useMediaQuery(theme.breakpoints.up("md"));

  const handleSuitChange = (
    _: React.MouseEvent<HTMLElement>,
    val: string | null
  ) => {
    if (val) {
      setSelectedSuit(val as SuitType);
      const suitLabel = SUITS.find((s) => s.value === val)?.label || "";
      setSelectedTitle(suitLabel);
    }
  };

  return (
    <Box sx={{ width: "100%" }}>
      {/* Responsive Heading */}
      <Typography
        sx={{
          mb: 2,
          fontSize: isXs ? "18px" : isSm ? "20px" : "24px",
          fontWeight: 700,
          color: "var(--neutral800)",
        }}
      >
        My Favorite Cards
      </Typography>

      {/* Responsive Toggle Button Section */}
      <Box
        sx={{
          mb: 4,
          display: "flex",
          justifyContent: isMdUp ? "flex-start" : "center",
        }}
      >
        <GradientToggleButtonGroup
          options={SUITS}
          value={selectedSuit}
          onChange={handleSuitChange}
        />
      </Box>

      {/* Cards for selected suit */}
      <RenderUserFavoriteCards suit={selectedSuit} title={selectedTitle} />
    </Box>
  );
};

export default MyBookmarks;
